import { useEffect, useMemo, useState } from "react";
import {
  listReferrals,
} from "../../services/librariesCatalogService";
import {
  REFERRAL_SOURCE_OPTIONS as FALLBACK_REFERRAL,
} from "./patientForm.shared";

/**
 * Load Active Libraries catalogs for patient demographics dropdowns.
 * Insurance names use server search on type (see insuranceCatalog.js).
 * Falls back to legacy hardcoded options when catalogs are empty.
 */
export default function useDemographicsLibraryOptions() {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const refRes = await listReferrals({
          status: "Active",
          limit: 100,
          sortBy: "referralName",
        });
        if (cancelled) return;
        setReferrals(refRes?.items || []);
      } catch {
        if (!cancelled) {
          setReferrals([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const referralSourceOptions = useMemo(() => {
    if (!referrals.length) return FALLBACK_REFERRAL;
    const opts = referrals.map((row) => ({
      value: row.referralName,
      label: row.category
        ? `${row.referralName} (${row.category})`
        : row.referralName,
      referralName: row.referralName,
      category: row.category,
      meta: row,
    }));
    if (!opts.some((o) => o.value === "Other")) {
      opts.push({ value: "Other", label: "Other", referralName: "", category: "" });
    }
    return opts;
  }, [referrals]);

  const findReferral = (sourceValue) =>
    referrals.find((r) => r.referralName === sourceValue) || null;

  return {
    loading,
    referralSourceOptions,
    findReferral,
  };
}
